<template>
  <div>
    <a-button type="primary" icon="plus-circle" @click="addPrediction()">新增下期预告</a-button>
    <div class="publish-table">
      <a-table size="middle" :pagination="false" :columns="columns" :loading="loading" :data-source="nextList"
               :rowKey="record=>record.id" style="margin-top: 20px">
        <img class="listCover" slot="cover" slot-scope="text" :src="text" alt="">
        <div slot="activity_start" slot-scope="text, record">
          <span> {{ text | time }} </span> 至 <span> {{ record.activity_end | time }} </span>
        </div>
        <span slot="status" slot-scope="text"> {{ text == 1 ? '进行中' : '已过期' }}</span>
        <div slot="operate" slot-scope="text, record">
          <a-button type="link" @click="check(record)">
            查看
          </a-button>
          <a-button type="link" v-if="record.status == 1" @click="edit(record)">
            编辑
          </a-button>
          <a-button type="link" @click="remove('delete', record)">
            删除
          </a-button>
        </div>
      </a-table>
    </div>
    <a-modal :destroyOnClose="true" title="当前封面" :width="568" @ok="submitForm" @cancel="handleCancel"
             :visible="newJournalVisible" :confirm-loading="confirmLoading">
      <a-form-model ref="newJournalForm" :model="form" :rules="newNextRules" :label-col="labelCol"
                    :wrapper-col="wrapperCol">
        <a-card class="cover" hoverable>
          <img slot="cover" style="height: 320px;" alt="example" :src="form.cover" loading />
        </a-card>
        <div class="recently">
          <p>最近上传</p>
          <img class="periodical" v-for="item in periodicalList" :key="item.id" :src="item.new_value" alt=""
               @click="changeCover(item.new_value)">
          <div>
            <a-upload name="file" :headers="{ token }" :before-upload="beforeUpload"
                      list-type="picture-card" class="avatar-uploader" :show-upload-list="true"
                      :action="`${baseURL}/public/upload-file-qi-niu`" @change="(data) => handleChange(data)"
                      :file-list="fileList" @preview="preview">
              <div v-if="fileList < 1">
                <a-icon type="upload" />
                <div class="ant-upload-text">本地上传</div>
              </div>
            </a-upload>
          </div>
        </div>
        <a-form-item label="预告时间" prop="activity_start">
          <a-range-picker @change="onDateChange" v-model="time" />
        </a-form-item>
        <a-form-model-item label="预告说明:" prop="remark">
          <a-textarea v-model="form.remark" allowClear :maxLength="512" placeholder="可对此期期刊的主题类型进行阐述"
                      auto-size />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal :visible="previewVisible" width="720px" :footer="null" @cancel="preViewCancel">
      <div class="preViewImg">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </div>
    </a-modal>
    <covers :newJournalForm="newJournalForm" :ischeck="ischeck" @changeVisible="(v) => {this.ischeck = v;}">
    </covers>
    <a-pagination style="text-align: right; margin-top: 20px" size="small" :total="pagination.total"
                  :defaultPageSize="10" show-size-changer show-quick-jumper :current="pagination.page"
                  @change="(page, size)=> pageChange(page, size)" @showSizeChange="(page, size)=> pageChange(page, size)" />
  </div>
</template>

<script>
import { nextColumns, newNextRules } from '../business/journalList'
import token from '@/composables/token'
import { strategyCommand } from '../business/tableList'
import { createNext, periodical, nextUpdate } from '@/api/journal/index'
import moment from 'moment'
import api from '@/api'
import Covers from './cover.vue'
import { mapState, mapGetters } from 'vuex'
import activity from '@/api/activity'
export default {
  props: {
    pagination: {
      type: Object,
      default: () => {
        return {}
      }
    },
    nextList: {
      type: Array,
      default() {
        return []
      }
    },
    activityTab: {
      type: Number,
      default() {
        return []
      }
    }
  },
  computed: {
    ...mapState({ labels: state => state.label.data })
  },
  components: {
    Covers
  },
  filters: {
    time(msg) {
      return (msg = moment(msg * 1000).format('YYYY-MM-DD'))
    }
  },
  data() {
    return {
      form: {
        cover: '',
        remark: '',
        activity_start: '',
        activity_end: ''
      },
      newNextRules: newNextRules,
      ischeck: false,
      newJournalForm: {
        cover: '',
        title: '',
        activity_start: '',
        activity_end: ''
      },
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      noticethat: {},
      defultDate: [],
      confirmLoading: false,
      newJournalVisible: false,
      timePicked: {},
      columns: nextColumns,
      loading: false,
      ...token(),
      baseURL: process.env.VUE_APP_API_BASE_URL,
      fileList: [],
      tableData: [],
      nextUpList: [],
      time: [],
      periodicalList: [],
        previewVisible: false,
        previewImage: '',
    }
  },
  methods: {
      preview(file) {
          this.previewImage = file.url || this.labels.QI_NIU_DOMAINS + '/' + file.response.data.url
          this.previewVisible = true
      },
      preViewCancel() {
          this.previewVisible = false
      },
    // 点击编辑
    edit(data) {
      this.form.cover = data.cover
      this.onDateChange(
        [moment(data.activity_start * 1000), moment(data.activity_end * 1000)],
        [moment(data.activity_start * 1000), moment(data.activity_end * 1000)]
      )
      this.form.remark = data.remark
      this.newJournalVisible = true
      this.form.id = data.id
    },
    // 最近上传列表
    async periodicalLog() {
      const { data } = await api.periodical()
      if (data) {
        this.periodicalList = data.modelLogs
      }
    },
    changeCover(a) {
      this.form.cover = a
    },
    addPrediction() {
      this.form.cover = this.periodicalList[0] ? this.periodicalList[0].new_value : ''
      this.newJournalVisible = true
    },
    pageChange(page, size) {
      this.pagination.page = page
      this.pagination.per_page = size
      this.$emit('updateList')
    },
    submitForm() {
      this.$refs.newJournalForm.validate(valid => {
        if (valid) {
          if (!this.form.id) {
            createNext(this.form).then(res => {
              if (this.$validate(res)) {
                this.time = []
                this.form = {
                  cover: '',
                  remark: '',
                  activity_start: '',
                  activity_end: ''
                }
                this.fileList = []
                this.newJournalVisible = false
                this.$emit('updateList')
              }
            })
          } else {
            nextUpdate(this.form).then(res => {
              if (this.$validate(res)) {
                this.time = []
                this.form = {
                  cover: '',
                  remark: '',
                  activity_start: '',
                  activity_end: ''
                }
                this.fileList = []
                this.newJournalVisible = false
                this.$emit('updateList')
              }
            })
          }
        }
      })
    },
    remove(type, ...arg) {
      strategyCommand[type].call(this, ...arg)
    },
    check(record) {
      this.ischeck = true
      Object.assign(this.newJournalForm, record, {
        title: record.remark
      })
    },
    handleCancel() {
      this.time = []
      this.fileList = []
      this.form = {
        cover: '',
        remark: '',
        activity_start: '',
        activity_end: ''
      }
      this.newJournalVisible = false
      // this.$refs.newJournalForm.resetFields()
    },
    onDateChange(val, format) {
      this.form = Object.assign({}, this.form, {
        activity_start: format[0],
        activity_end: format[1]
      })
      this.time = val
    },
    handleChange(data) {
      this.fileList = data.fileList
      this.form.cover = data.fileList[0]?.response
        ? this.labels.QI_NIU_DOMAINS + '/' + data.fileList[0].response.data.url
        : ''
      if (data.file.status === 'removed') {
        this.form.cover = this.periodicalList[0].new_value
      }
    },
    beforeUpload(file) {
      return new Promise((resolve, reject) => {
        const isJpgOrPng =
          file.type === 'image/jpeg' ||
          file.type === 'image/png' ||
          file.type === 'image/png' ||
          file.type === 'image/gif'
        if (!isJpgOrPng) {
          this.$message.error('请上传图片!')
          return reject(new Error(false))
        }
        const isLt2M = file.size / 1024 / 1024 <= 2
        if (!isLt2M) {
          this.$message.error('图片大小不超过 2MB!')
          return reject(new Error(false))
        }
        return resolve(true)
      })
    }
  },
  mounted() {
    this.$emit('updateList', this.pagination)
    this.periodicalLog()
  }
}
</script>

<style lang="less" scoped>
.cover {
  display: inline-block;
  width: 260px;
  margin-bottom: 20px;
}
.listCover {
  width: 100px;
  height: 60px;
}
.ant-table-small > .ant-table-content > .ant-table-body {
  margin: 0;
}
.btn {
  margin-right: 20px;
}
.recently {
  display: inline-block;
  width: 230px;
  height: 320px;
  margin-left: 30px;
  vertical-align: top;
  position: relative;
  .avatar-uploader {
    position: absolute;
    left: 20%;
    bottom: -10px;
  }
  .periodical {
    margin: 0 10px 10px 0;
    width: 60px;
    height: 70px;
  }
}
.preViewImg {
    padding: 10px 20px;
}
</style>
